//Keybord keys
export const TAB_KEYCODE = 9;
export const ENTER_KEYCODE = 13;
export const ESCAPE_KEYCODE = 27;
export const SPACE_KEYCODE = 32;
export const ARROW_RIGHT_KEY = 'ArrowRight';
export const ARROW_LEFT_KEY = 'ArrowLeft';
export const ARROW_UP_KEY = 'ArrowUp';
export const ARROW_DOWN_KEY = 'ArrowDown';
export const ENTER_KEY = 'Enter';
export const ESCAPE_KEY = 'Escape';
export const PLACEMENT_TOP_LEFT = 'placement-top-left';
export const PLACEMENT_TOP_RIGHT = 'placement-top-right';
export const PLACEMENT_BOTTOM_RIGHT = 'placement-bottom-right';
export const PLACEMENT_BOTTOM_LEFT = 'placement-bottom-left';
export const PLACEMENT_MAPPING = {
  top: 'top',
  topLeft: 'top-start',
  topRight: 'top-end',
  bottom: 'bottom',
  bottomLeft: 'bottom-start',
  bottomRight: 'bottom-end'
};
//Modal headerVariants:
export const HEADER_VARIANTS = {
  DEFAULT: '',
  ACCENT: 'accent'
};

//Button variants
export const BUTTON_VARIANTS = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TERTIARY: 'tertiary',
  DESTRUCTIVE: 'destructive'
};

//Sizes
export const SIZES = {
  SMALL: 'sm',
  MEDIUM: 'md',
  LARGE: 'lg'
};
export const EVENT_TYPES = {
  SHOW_NAVIGATION: 'showNavigation',
  UPDATE_GH_BADGE: 'updateGHBadge'
};